export default "__VITE_ASSET__Ds2qknBZ__"